import apisauce from "apisauce";
import { configApp, hotToast } from "../utils";
import { store } from "store/configureStore";
import { AxiosError } from "axios";

const create = (endpoint = configApp.api) => {
  const currentDomain = `${window.location.origin}/not-autorized`;
  const middlewareSuccess = (response: any) => {
    try {
      // 🧩 Si no hay respuesta, es un fallo de red o de conexión
      if (!response) {
        console.warn("⚠️ No se recibió respuesta del servidor (posible timeout o conexión bloqueada)");
        hotToast("Hubo un error ", "WAR");
        return {};
      }

      // 🧠 Si el backend responde con 401
      if (response.status === 401) {
        hotToast("Tu sesión ha expirado. Por favor inicia sesión nuevamente.", "WAR");
        handleSessionLogout();
        return {};
      }

      // 🌐 Si Apisauce o Axios marca error de red
      if (response.problem === "NETWORK_ERROR" || response.problem === "TIMEOUT_ERROR") {
        console.warn("⚠️ Error de red o tiempo de espera agotado");
        hotToast("No hay conexión con el servidor. Intenta nuevamente.", "WAR");
        handleSessionLogout();
        return {};
      }

      // ✅ Si todo está bien, retorna el response
      return response;
    } catch (err) {
      console.error("🔥 Excepción en middlewareSuccess:", err);
      hotToast("Error inesperado. Inicia sesión nuevamente.", "ERROR");
      handleSessionLogout();
      return {};
    }
  };

  function handleSessionLogout() {
    localStorage.removeItem("persist:root");
    sessionStorage.clear();
    window.location.href = "/login";
  }
  const middleware401 = (response: AxiosError) => {
    if (response.response?.status === 401) {
      //window.location.href = currentDomain;
    }
    return null;
  };
  const api = apisauce.create({
    baseURL: endpoint,
    timeout: 122000,
  });

  const postLogin = (data: any) => api.post("user/auth", data);

  const requestPost = (endpoint: string, data: any) =>
    api.post(endpoint, data).then(middlewareSuccess).catch(middleware401);
  const requestGet = (endpoint: string) =>
    api.get(endpoint).then(middlewareSuccess).catch(middleware401);
  const requestPut = (endpoint: string, data: any) =>
    api.put(endpoint, data).then(middlewareSuccess).catch(middleware401);
  const requestDelete = (endpoint: string, data: any) =>
    api.delete(endpoint, data).then(middlewareSuccess).catch(middleware401);

  const setToken = async () => {
    try {
      let jwt: string = store.getState().user.jwt;
      api.setHeader("Authorization", "Bearer " + jwt);
    } catch (error) {
      console.error(error);
    }
  };

  const setHeaderFormFiles = () =>
    api.setHeader("Content-Type", "Multipart/form-data");
  const removeHeaderFormFiles = () => api.deleteHeader("Content-Type");
  const removeToken = () => api.deleteHeader("Authorization");

  return {
    postLogin,
    requestPost,
    requestGet,
    requestPut,
    setToken,
    removeToken,
    requestDelete,
    setHeaderFormFiles,
    removeHeaderFormFiles,
  };
};

const api = create();

export default api;
